import * as bank from '../types/bank'

export const initialState = {
    name: '',
    agency: '',
    digit: ''
}

export const bankReducer = (state = initialState, action = { type: '' }) => {
    switch (action.type) {
        case bank.SET_NAME:
            return { ...state, name: action.payload.name }

        case bank.SET_INFO: {
            const info = action.payload.info
            return { ...state, agency: info.agency, digit: info.digit }
        }
        case bank.RESET:
            return { ...initialState }

        default:
            return state
    }
}
